import {
  Award,
  FileCheck,
  FileDigit,
  Globe2,
  Network,
  Recycle,
  RefreshCcw,
  User,
} from "lucide-react";
import { useTranslation } from "react-i18next";

import { proServicesKeys } from "@/constants/proServices";

import OptionItem from "./OptionItem";

export type ProServiceKey = (typeof proServicesKeys)[number];

const iconMap = {
  service1: Recycle,
  service2: RefreshCcw,
  service3: FileDigit,
  service4: User,
  service5: Award,
  service6: FileCheck,
  service7: Globe2,
  service8: Network,
};

function ProServicesContent() {
  const { t } = useTranslation("options");

  return (
    <ul className="gap-md grid grid-cols-1 md:grid-cols-2">
      {proServicesKeys.map((proServiceKey) => {
        const icon = iconMap[proServiceKey as keyof typeof iconMap];

        return (
          <li key={proServiceKey}>
            <OptionItem
              optionKey={proServiceKey}
              title={t(
                `options:byProServices.serviceList.${proServiceKey}.title`
              )}
              description={t(
                `options:byProServices.serviceList.${proServiceKey}.description`
              )}
              href={"/options/subscription"}
              tag={t(`options:byProServices.serviceList.${proServiceKey}.tag`)}
              Icon={icon}
            />
          </li>
        );
      })}
    </ul>
  );
}

export default ProServicesContent;
